const colors = ['#ff987c', '#ff96b8', '#a46bd7', '#8fdeff', '#cfde68']

const GetAvatarColor = (name) => {
  let hash = 0
  if (name.length === 0) {
    return colors[0]
  }

  for (let i = 0; i < name.length; i++) {
    let char = name.charCodeAt(i)
    hash = hash + char
  }
  return colors[hash % colors.length]
}

export default GetAvatarColor



// WEBPACK FOOTER //
// ./src/Lib/GetAvatarColor.js